document.addEventListener('DOMContentLoaded', function () {
  const tabLists = document.querySelectorAll('[id^="collection-tabs-list-"]');

  if (!tabLists.length) return;

  tabLists.forEach(function (tabsWrap) {
    const sectionId = tabsWrap.id.replace('collection-tabs-list-', '');
    const contentWrap = document.getElementById('collection-tabs-content-' + sectionId);
    const viewAllLink = document.getElementById('collection-tabs-viewall-' + sectionId);

    if (!contentWrap) return;

    const tabs = tabsWrap.querySelectorAll('.collection-tabs__list-link');
    const panels = contentWrap.querySelectorAll('.collection-tabs__panel');

    if (!tabs.length || !panels.length) return;

    function updateViewAll(tab) {
      if (!viewAllLink || !tab) return;
      const url = tab.getAttribute('data-url');
      viewAllLink.setAttribute('href', url && url !== '' ? url : '#');
    }

    function getSliderFromPanel(panel) {
      if (!panel) return null;
      return panel.querySelector('slide-show');
    }

    function getFlickityInstance(panel) {
      if (!window.Flickity || !panel) return null;

      const slider = getSliderFromPanel(panel);
      if (!slider) return null;

      let flkty = Flickity.data(slider);
      if (flkty) return flkty;

      const enabledInside = slider.querySelector('.flickity-enabled');
      if (enabledInside) {
        flkty = Flickity.data(enabledInside);
        if (flkty) return flkty;
      }

      return null;
    }

    function refreshPanelSlider(panel) {
      const slider = getSliderFromPanel(panel);
      if (!slider) return;

      const doRefresh = function () {
        const flkty = getFlickityInstance(panel);

        if (flkty) {
          flkty.reloadCells();
          flkty.resize();
          flkty.reposition();
          flkty.select(0);
        }

        slider.dispatchEvent(new Event('resize'));
        window.dispatchEvent(new Event('resize'));
      };

      setTimeout(doRefresh, 60);
      setTimeout(doRefresh, 180);
      setTimeout(doRefresh, 320);
    }

    function activateTab(selectedCollection, clickedTab) {
      let activePanel = null;

      tabs.forEach(function (tab) {
        const isMatch = tab.getAttribute('data-collection') === selectedCollection;
        tab.classList.toggle('active', isMatch);
      });

      panels.forEach(function (panel) {
        const isMatch = panel.getAttribute('data-panel') === selectedCollection;
        panel.classList.toggle('active', isMatch);
        panel.setAttribute('aria-hidden', isMatch ? 'false' : 'true');

        if (isMatch) activePanel = panel;
      });

      if (clickedTab) {
        updateViewAll(clickedTab);
      }

      if (activePanel) {
        refreshPanelSlider(activePanel);
      }
    }

    const activeTab = tabsWrap.querySelector('.collection-tabs__list-link.active') || tabs[0];

    if (activeTab) {
      activateTab(activeTab.getAttribute('data-collection'), activeTab);
    }

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function (e) {
        e.preventDefault();
        activateTab(this.getAttribute('data-collection'), this);
      });
    });
  });
});